import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, ArrowRight } from 'lucide-react';
export const OrderSupport = () => {
  return <div className="py-20 lg:py-24 bg-gray50 min-h-[calc(100vh-300px)]" data-id="element-842">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-843">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-844">
          <div className="w-20 h-20 bg-brandRed/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-845">
            <HelpCircle className="w-10 h-10 text-brandRed" data-id="element-846" />
          </div>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-6 leading-tight" data-id="element-847">
            Order Support
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-848">
            Need help placing an order, checking status, or managing your
            roster? We're here to assist.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-2xl border border-gray200 shadow-sm" data-id="element-849">
          <div className="space-y-8" data-id="element-850">
            <div data-id="element-851">
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-852">
                How do I place an order?
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-853">
                If you are a registered dealer, you can submit your order
                directly through your account portal. If you are an end-user,
                please use our online designer to build your uniform, and we
                will connect you with a dealer to finalize the purchase.
              </p>
            </div>

            <div data-id="element-854">
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-855">
                What is the standard turnaround time?
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-856">
                Standard production time is typically 3-4 weeks from the date of
                final artwork approval and payment. Rush options may be
                available for select items.
              </p>
            </div>

            <div data-id="element-857">
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-858">
                How do I submit my roster?
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-859">
                Rosters should be submitted using our standard template format
                to ensure accuracy. Please double-check all spelling and sizing
                before submission, as custom items cannot be returned.
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-gray200 text-center" data-id="element-860">
            <p className="text-lg text-ink font-bold mb-6" data-id="element-861">Still need help?</p>
            <Link to="/contact" className="inline-flex items-center justify-center gap-2 bg-brandRed hover:bg-brandRedDark text-white font-bold py-3.5 px-8 rounded-sm transition-colors" data-id="element-862">
              Contact Support
              <ArrowRight className="w-5 h-5" data-id="element-863" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
};